import classNames from 'classnames';
import { FunctionComponent, useMemo } from 'react';
import styles from './styles.module.scss';
import { SupportedCurrencies } from '@cademy-package/sdk-component-types';

export const GiftAmountRadio: FunctionComponent<{
    isSelected: boolean;
    amount: number;
    setAmount: (amount: number) => void;
    currency: SupportedCurrencies;
}> = ({ isSelected, amount, setAmount, currency }) => {
    const currencySymbol = useMemo(() => {
        try {
            const format = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol',
            })
                .formatToParts(0)
                .find((part) => part.type === 'currency');

            if (format) {
                return format.value;
            }

            return '';
        } catch (error) {
            console.error(error);
            return '';
        }
    }, [currency]);

    return (
        <label
            htmlFor={`gift-amount-${amount}`}
            className={classNames(styles.amount_card, {
                [`${styles.amount_card_selected}`]: isSelected,
            })}
        >
            <input
                type="radio"
                id={`gift-amount-${amount}`}
                value={String(amount)}
                checked={isSelected}
                onChange={() => setAmount(amount)}
                className={styles.amount_card_input}
            />
            <span style={{ fontSize: '14px' }}>
                {currencySymbol}
                {amount}
            </span>
        </label>
    );
};
